import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { AiTeammatesPage } from "@/components/seo/ai-teammates-page";
import {
	AI_TEAMMATES_FAQ_SCHEMA_ITEMS,
	AI_TEAMMATES_META_DESCRIPTION,
	AI_TEAMMATES_PAGE_TITLE,
} from "@/constants/seo/ai-teammates-content";
import {
	buildBreadcrumb,
	buildFAQ,
	buildSoftwareApplication,
	buildWebPage,
	jsonLdScript,
} from "@/lib/seo/json-ld";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";

export const Route = createFileRoute("/ai-teammates")({
	head: () => {
		const canonical = getCanonical("/ai-teammates");
		const meta = buildMetaTags({
			title: "AI Teammates for Marketing & Ops",
			description: AI_TEAMMATES_META_DESCRIPTION,
			canonical,
			ogType: "website",
		});

		const schemas = [
			buildWebPage({
				name: AI_TEAMMATES_PAGE_TITLE,
				description: AI_TEAMMATES_META_DESCRIPTION,
				url: canonical,
			}),
			buildFAQ(AI_TEAMMATES_FAQ_SCHEMA_ITEMS),
			buildBreadcrumb([
				{ name: "Home", url: getCanonical("/") },
				{ name: "AI Teammates", url: canonical },
			]),
			buildSoftwareApplication({ ratingValue: 4.8, ratingCount: 50, price: "0" }),
		];

		return {
			meta,
			links: buildLinks({ canonical }),
			scripts: schemas.map(jsonLdScript),
		};
	},
	component: AiTeammatesRouteComponent,
});

function AiTeammatesRouteComponent() {
	const { pathname } = useLocation();
	const normalizedPath = pathname.replace(/\/+$/, "") || "/";

	if (normalizedPath === "/ai-teammates") {
		return <AiTeammatesPage />;
	}

	return <Outlet />;
}
